import { render, staticRenderFns } from "./processing-status-organizations-detail.view.vue?vue&type=template&id=be482b20&"
import script from "./processing-status-organizations-detail.view.vue?vue&type=script&lang=ts&"
export * from "./processing-status-organizations-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports